import { render, staticRenderFns } from "./JImageUpload.vue?vue&type=template&id=77c65a51&scoped=true"
import script from "./JImageUpload.vue?vue&type=script&lang=js"
export * from "./JImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c65a51",
  null
  
)

export default component.exports